import { Model, Attr, BelongsTo, HasOne, HasMany } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';
import moment from 'moment';

@Model()
export default class ContactSubmission extends ApplicationRecord {
  static jsonapiType = 'contact-submissions';

  static listHeaders() {
    return [
      {
        text: 'Name',
        value: 'name',
      },
      {
        text: 'Email',
        value: 'email',
      },
      {
        text: 'Sent Date',
        value: 'created',
        width: 180,
      },
    ];
  }

  static scopeFactory() {
    return ContactSubmission.includes([]);
  }

  static defaultOptions() {
    return {
      sortBy: ['created'],
      sortDesc: [true],
    };
  }

  @Attr() created: string;
  @Attr() name: string;
  @Attr() phoneNumber: string;
  @Attr() email: string;
  @Attr() message: string;

  get formattedDate() {
    if (!this.created) {
      return;
    }
    return moment(this.created).format('MMM D, YYYY h:mm a');
  }
}
